// ============================================================================
// FITCLUTCH — CONFIGURAÇÃO DO FUNIL COMPLETO DE ONBOARDING (VERSÃO WEB)
// ============================================================================
// Sincronizado em 16/09/2026 com o conteúdo REAL já em produção no app
// mobile (fitclutch-mobile/src/config/quizConfig.pt.js) — imagens
// (Cloudinary), textos e preços copiados de lá, não são mais placeholders.
// A etapa 'health_connect' foi deixada de fora de propósito (no app mobile
// ela existe nos dados mas fica escondida até a integração real com
// HealthKit/Google Fit acontecer — ver comentário da Gladis lá, 14/09/2026).
//
// Se a Gladis mandar uma imagem/preço novo, atualize aqui E no arquivo do
// mobile pra manter os dois sincronizados (ainda não são compartilhados
// automaticamente entre os dois projetos).
// ============================================================================

export const quizSteps = [
  // ETAPA 1 — tela de entrada do funil, redesenhada em 01/10/2026 pra seguir
  // a estrutura da tela inicial do Befit (ver pesquisa-concorrentes.md):
  // headline + "powered by AI" + seleção de faixa etária com foto, em vez do
  // antigo vídeo de capa + botão "Começar". Textos vêm do i18n (ver
  // src/i18n/strings.*.js, chave "ageSelect.*") — nada fixo em português
  // aqui, pros 8 mercados. Imagens são placeholders de banco de imagens
  // (Pexels) — Gladis troca pelas definitivas depois.
  {
    id: 'age_select',
    type: 'age-select',
    ageRanges: [
      {
        value: '18-29',
        min: 18,
        max: 29,
        image: '/quiz/age/age-18-29.webp',
      },
      {
        value: '30-39',
        min: 30,
        max: 39,
        image: '/quiz/age/age-30-39.webp',
      },
      {
        value: '40-49',
        min: 40,
        max: 49,
        image: '/quiz/age/age-40-49.webp',
      },
      {
        value: '50+',
        min: 50,
        max: 99,
        image: '/quiz/age/age-50-plus.webp',
      },
    ],
  },
  // ETAPA 2 — redesenhada em 01/10/2026 pra seguir a tela "What is your
  // gender" do Befit: 2 fotos grandes lado a lado em vez da lista com
  // ícone pequeno. Textos vêm do i18n (ageSelect.* / gender.*). Imagens
  // placeholder de banco de imagens (Pexels) — Gladis troca depois.
  {
    id: 'gender',
    type: 'gender-select',
    step: 1,
    totalSteps: 21,
    images: {
      male: '/quiz/gender/gender-male.webp',
      female: '/quiz/gender/gender-female.webp',
    },
  },
  // ETAPA transitória (sem número/barra de progresso, igual 'transformation'
  // e 'weight_prediction' mais abaixo) — segue a estrutura da tela "Over
  // 300,000 women..." do Befit (print enviado pela Gladis em 01/10/2026):
  // prova social com foto grande + selo de avaliação nas lojas. Números
  // abaixo são placeholder (marcados TODO) até a Gladis confirmar os
  // números reais do FitClutch antes de publicar — NUNCA usar os números
  // do Befit, são deles. O título é montado dinamicamente a partir das
  // respostas de gênero/idade já dadas (ex: "mulheres", "na casa dos 30").
  // Imagem também muda por gênero (pedido da Gladis, 01/10/2026: no Befit a
  // foto mostrava uma mulher porque ela tinha escolhido "female" lá —
  // aqui tem que acompanhar a resposta real da pessoa, não ficar fixo).
  {
    id: 'social_proof_intro',
    type: 'social-proof',
    images: {
      male: '/quiz/social-proof/social-male.webp',
      female: '/quiz/social-proof/social-female.webp',
      other: 'https://images.pexels.com/photos/4164761/pexels-photo-4164761.jpeg?auto=compress&cs=tinysrgb&w=800',
    },
    // TODO(Gladis): confirmar número real de usuários/avaliação antes do lançamento.
    stats: {
      users: '50,000+',
      appStoreRating: '4.8',
      googlePlayRating: '4.7',
    },
  },
  // Reordenada em 01/10/2026 (pedido da Gladis: "quero no mesmo sentido do
  // Befit, eles já validaram esse fluxo") — a pergunta de objetivo vem logo
  // depois da prova social, igual à sequência real do Befit
  // (age → gender → social proof → goal), e não mais lá atrás depois de
  // experience/frequency. Os VALUES das opções (condicionamento/forca/
  // emagrecer/hipertrofia) são usados pelo gerador de plano
  // (planGenerator.js/aiPlanAdvisor.js/fitnessScore.js) — NUNCA mudar esses
  // values, só a posição/apresentação. Textos vêm do i18n (goal.*), nenhum
  // fixo em português.
  {
    id: 'goal',
    type: 'goal-select',
    step: 2,
    totalSteps: 21,
    options: [
      { value: 'hipertrofia', icon: 'ti-barbell' },
      { value: 'emagrecer', icon: 'ti-scale' },
      { value: 'forca', icon: 'ti-bolt' },
      { value: 'condicionamento', icon: 'ti-trending-up' },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "Which of these best
  // matches your shape today?" do Befit: grade 2x2 com FOTO (não ícone —
  // corrigido a pedido da Gladis: "precisa colocar imagens pra eu
  // substituir depois", mesmo padrão já usado em age_select/gender: foto +
  // rótulo embaixo, placeholder de banco de imagens trocado pela foto
  // definitiva depois). Foto muda por gênero igual nas outras telas.
  // Seleção única que avança sozinha (sem botão Continuar). Resposta
  // guardada como 'body_shape' pra uso futuro na personalização do plano
  // (ainda não é obrigatória pro gerador atual).
  {
    id: 'body_shape',
    type: 'body-shape-select',
    step: 3,
    totalSteps: 21,
    options: [
      {
        value: 'magro',
        images: {
          male: '/quiz/body-shape/shape-magro-male.webp',
          female: '/quiz/body-shape/shape-magro-female.webp',
        },
      },
      {
        value: 'cheio',
        images: {
          male: '/quiz/body-shape/shape-cheio-male.webp',
          female: '/quiz/body-shape/shape-cheio-female.webp',
        },
      },
      {
        value: 'atletico',
        images: {
          male: '/quiz/body-shape/shape-atletico-male.webp',
          female: '/quiz/body-shape/shape-atletico-female.webp',
        },
      },
      {
        value: 'medio',
        images: {
          male: '/quiz/body-shape/shape-medio-male.webp',
          female: '/quiz/body-shape/shape-medio-female.webp',
        },
      },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "Which body type are you
  // aiming for?" do Befit: lista só ícone + rótulo (mesmo padrão visual de
  // 'experience' logo abaixo), seleção única que avança sozinha (sem botão
  // Continuar). Resposta guardada como 'body_goal' — ainda não é obrigatória
  // pro gerador de plano atual (igual 'body_shape'), só personalização
  // futura. Textos vêm do i18n (bodyGoal.*), nenhum fixo em português.
  {
    id: 'body_goal',
    type: 'body-goal-select',
    step: 4,
    totalSteps: 21,
    options: [
      { icon: 'ti-flame', value: 'definido' },
      { icon: 'ti-barbell', value: 'atletico' },
      { icon: 'ti-leaf', value: 'magro' },
      { icon: 'ti-hourglass', value: 'curvilineo' },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "When did you last feel
  // your best physically?" do Befit: lista só ícone + rótulo (mesmo padrão
  // visual de 'body_goal'/'experience'), seleção única que avança sozinha
  // (sem botão Continuar). Resposta guardada como 'last_felt_best' — ainda
  // não é obrigatória pro gerador de plano atual, só contexto/motivação
  // pra personalização futura. Textos vêm do i18n (lastBest.*), nenhum
  // fixo em português (sem gênero aqui — nenhuma das opções flexiona).
  {
    id: 'last_felt_best',
    type: 'last-best-select',
    step: 5,
    totalSteps: 21,
    options: [
      { icon: 'ti-calendar-check', value: 'agora' },
      { icon: 'ti-calendar-time', value: 'menos_1_ano' },
      { icon: 'ti-hourglass', value: '1_3_anos' },
      { icon: 'ti-refresh', value: 'mais_3_anos' },
      { icon: 'ti-ban', value: 'nunca' },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "How does your weight
  // typically change?" do Befit: lista só ícone + rótulo, seleção única
  // que avança sozinha (sem botão Continuar). Resposta guardada como
  // 'weight_trend' — contexto/motivação, não obrigatória pro gerador
  // atual. Textos via i18n (weightTrend.*), sem gênero (nenhuma opção
  // flexiona).
  {
    id: 'weight_trend',
    type: 'weight-trend-select',
    step: 6,
    totalSteps: 21,
    options: [
      { icon: 'ti-arrow-right', value: 'estavel' },
      { icon: 'ti-pulse', value: 'varia' },
      { icon: 'ti-trending-up', value: 'subindo' },
      { icon: 'ti-trending-down', value: 'caindo' },
      { icon: 'ti-help', value: 'nao_sei' },
    ],
  },
  // Nova em 01/10/2026 — tela transitória (sem número/barra de progresso,
  // igual 'transformation' mais abaixo) que segue a estrutura da tela
  // "From {body} to athletic and muscular — we'll show you exactly how"
  // do Befit: título monta dinamicamente a partir das respostas reais de
  // 'body_shape' (corpo atual) e 'body_goal' (corpo desejado), já dadas
  // antes — nunca texto fixo. Imagem é PRINT DE VERDADE do app FitClutch
  // (pedido da Gladis, 01/10/2026: "aqui vamos colocar print do app") —
  // por isso fica como placeholder até ela mandar a captura de tela real,
  // nada de foto de banco de imagens aqui.
  {
    id: 'body_transform_promo',
    type: 'transform-promo',
    appScreenshot: '/quiz/app/app-preview-1.webp',
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "What's your max push-ups
  // in one go?" do Befit: lista só ícone + rótulo, seleção única que avança
  // sozinha (sem botão Continuar). Resposta guardada como 'push_ups' — pode
  // ajudar no cálculo de fitness score futuramente (igual 'experience'),
  // ainda não obrigatória pro gerador atual. Mesmo ícone repetido pros 4
  // níveis de quantidade (igual já fazemos em 'days_per_week' com
  // ti-calendar-2/3/4), já que não temos um ícone de flexão específico.
  // REORDENADA em 01/10/2026 (pedido da Gladis: "o máximo de flexões é
  // depois dessa tela aqui") — vem logo DEPOIS da promo de transformação,
  // não antes.
  {
    id: 'push_ups',
    type: 'push-ups-select',
    step: 7,
    totalSteps: 21,
    // Pedido da Gladis (01/10/2026): "coloca os ícones de acordo, não tudo
    // igual" — ícone escalando por nível de intensidade (mesmo padrão já
    // usado em 'experience': ti-bolt < ti-flame < ti-trending-up < ti-trophy).
    options: [
      { icon: 'ti-ban', value: 'nenhuma' },
      { icon: 'ti-bolt', value: '1_5' },
      { icon: 'ti-flame', value: '6_15' },
      { icon: 'ti-trending-up', value: '16_30' },
      { icon: 'ti-trophy', value: '30_mais' },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "How many squats can you
  // do in a row without a break?" do Befit, que vem logo depois da de
  // flexões. Mesma lógica de 'push_ups' (ícone repetido, avança sozinho).
  // Pedido da Gladis: "não faça exatamente igual, sempre deixe melhor" —
  // pergunta e opções com texto próprio (não tradução literal), faixas de
  // número adaptadas já que agachamento rende mais repetições que flexão.
  {
    id: 'squats',
    type: 'squats-select',
    step: 8,
    totalSteps: 21,
    // Mesmo ajuste de ícones escalando por intensidade (pedido da Gladis,
    // 01/10/2026), igual 'push_ups'.
    options: [
      { icon: 'ti-ban', value: 'nenhuma' },
      { icon: 'ti-bolt', value: '1_10' },
      { icon: 'ti-flame', value: '11_25' },
      { icon: 'ti-trending-up', value: '26_50' },
      { icon: 'ti-trophy', value: '50_mais' },
    ],
  },
  // Nova em 01/10/2026 — segue a estrutura da tela "How flexible are you?"
  // do Befit, que vem logo depois da de agachamentos. Lista só ícone +
  // rótulo, avança sozinho (sem botão Continuar). Ícones escalando por
  // nível, igual push_ups/squats (ti-ban = não consegue, até ti-trophy =
  // muito flexível), com ti-help separado pra "não sei".
  {
    id: 'flexibility',
    type: 'flexibility-select',
    step: 9,
    totalSteps: 21,
    options: [
      { icon: 'ti-ban', value: 'nao_alcanco' },
      { icon: 'ti-bolt', value: 'quase' },
      { icon: 'ti-flame', value: 'facil' },
      { icon: 'ti-trophy', value: 'muito_flexivel' },
      { icon: 'ti-help', value: 'nao_sei' },
    ],
  },
  // Nova em 01/10/2026 — tela transitória (sem número/barra de progresso,
  // igual 'body_transform_promo') que segue a estrutura da tela "Your
  // starting point is set. Now let's watch it move." do Befit: promete
  // acompanhamento automático de progresso. Imagem é PRINT DE VERDADE do
  // app FitClutch (dashboard de progresso semanal) — fica como placeholder
  // até a Gladis mandar a captura real, nada de foto de banco de imagens.
  {
    id: 'progress_promo',
    type: 'progress-promo',
    appScreenshot: '/quiz/app/app-preview-2.webp',
  },
  // REORDENADA em 01/10/2026 (pedido da Gladis: "tem que vir depois dessa
  // tela") — vem logo depois da promo de progresso, antes do nível de
  // condicionamento (não mais lá na frente perto de 'age'). Segue a
  // estrutura da tela "What are your target zones?" do Befit: lista de 4
  // zonas à esquerda + imagem do corpo à direita que ACENDE a zona
  // escolhida. PRIMEIRA tentativa foi um SVG geométrico desenhado à mão —
  // a Gladis achou feio. Depois, a Gladis gerou no ChatGPT uma grade 2x2
  // (superior/core/inferior/corpo inteiro, músculos em ciano) + 1 imagem
  // neutra (nenhuma zona acesa, estado inicial antes de escolher) —
  // recortadas aqui em 4 arquivos separados. Gênero-aware igual
  // body_shape/social_proof: masculino e feminino prontos
  // (`public/focus-area/male-*.png` / `female-*.png`).
  {
    id: 'focus_area',
    type: 'target-zone-select',
    step: 10,
    totalSteps: 21,
    images: {
      male: {
        neutral: '/focus-area/male-neutral.png',
        superior: '/focus-area/male-superior.png',
        core: '/focus-area/male-core.png',
        inferior: '/focus-area/male-inferior.png',
        corpo_inteiro: '/focus-area/male-corpo_inteiro.png',
      },
      female: {
        neutral: '/focus-area/female-neutral.png',
        superior: '/focus-area/female-superior.png',
        core: '/focus-area/female-core.png',
        inferior: '/focus-area/female-inferior.png',
        corpo_inteiro: '/focus-area/female-corpo_inteiro.png',
      },
    },
    options: [
      { value: 'superior' },
      { value: 'core' },
      { value: 'inferior' },
      { value: 'corpo_inteiro' },
    ],
  },
  {
    id: 'injuries',
    type: 'multi-select-grid',
    step: 11,
    totalSteps: 21,
    options: [
      { value: 'ombros', images: { male: '/quiz/injuries/injury-ombros-male.webp', female: '/quiz/injuries/injury-ombros-female.webp' } },
      { value: 'joelhos', images: { male: '/quiz/injuries/injury-joelhos-male.webp', female: '/quiz/injuries/injury-joelhos-female.webp' } },
      { value: 'costas', images: { male: '/quiz/injuries/injury-costas-male.webp', female: '/quiz/injuries/injury-costas-female.webp' } },
      { value: 'nenhuma', images: { male: '/quiz/injuries/injury-nenhuma-male.webp', female: '/quiz/injuries/injury-nenhuma-female.webp' } },
    ],
  },
  {
    id: 'workout_duration',
    type: 'options-icon',
    step: 12,
    totalSteps: 21,
    i18nKey: 'workoutDuration',
    options: [
      { icon: 'ti-bolt', value: 'rapido', subtitle: true, badge: true },
      { icon: 'ti-hourglass', value: 'curto', subtitle: true, badge: true },
      { icon: 'ti-flame', value: 'medio', subtitle: true, badge: true, recommended: true },
      { icon: 'ti-sparkles', value: 'longo', subtitle: true, badge: true },
    ],
  },
  {
    id: 'days_per_week',
    type: 'options-icon',
    step: 13,
    totalSteps: 21,
    question: 'Quantos dias por semana você quer treinar?',
    subtitle: 'Vamos montar seu plano com exatamente essa quantidade de treinos.',
    options: [
      { icon: 'ti-calendar-2', label: '2-3 dias', subtitle: 'Ideal pra começar com consistência', value: 2 },
      { icon: 'ti-calendar-3', label: '3-4 dias', subtitle: 'Equilíbrio entre treino e descanso', value: 4, recommended: true },
      { icon: 'ti-calendar-4', label: '5-6 dias', subtitle: 'Para quem já tem rotina consolidada', value: 6 },
      { icon: 'ti-calendar-check', label: 'Todos os dias', subtitle: 'Inclui treinos leves de recuperação', value: 7 },
    ],
  },
  // Tela de transição (sem número de step, igual body_transform_promo /
  // progress_promo) — confirma pro usuário a frequência + duração que
  // acabou de escolher, puxando os valores de days_per_week/workout_duration
  // pro título. Print do app ainda como placeholder (Gladis vai trazer).
  {
    id: 'training_summary_promo',
    type: 'training-summary-promo',
    appScreenshot: '/quiz/app/app-preview-4.webp',
  },
  {
    id: 'work_schedule',
    type: 'options-icon',
    step: 14,
    totalSteps: 21,
    i18nKey: 'workSchedule',
    options: [
      { icon: 'ti-sunny', value: 'fixo' },
      { icon: 'ti-moon', value: 'noturno' },
      { icon: 'ti-refresh', value: 'flexivel' },
      { icon: 'ti-bed', value: 'parado' },
    ],
  },
  {
    id: 'daily_activity',
    type: 'options-icon',
    step: 15,
    totalSteps: 21,
    i18nKey: 'dailyActivity',
    options: [
      { icon: 'ti-body', value: 'sentado' },
      { icon: 'ti-walk', value: 'ativo' },
      { icon: 'ti-swap', value: 'misto' },
      { icon: 'ti-help', value: 'nao_sei' },
    ],
  },
  {
    id: 'sleep_hours',
    type: 'options-icon',
    step: 16,
    totalSteps: 21,
    i18nKey: 'sleepHours',
    options: [
      { icon: 'ti-moon', value: 'menos_5' },
      { icon: 'ti-sparkles', value: '5_6' },
      { icon: 'ti-shield-check', value: '7_8' },
      { icon: 'ti-sunny', value: 'mais_8' },
    ],
  },
  {
    id: 'water_intake',
    type: 'water-intake-select',
    step: 17,
    totalSteps: 21,
    min: 1,
    max: 8,
  },
  {
    id: 'height',
    type: 'ruler-slider',
    step: 18,
    totalSteps: 21,
    question: 'Qual a sua altura?',
    units: ['cm', 'ft/in'],
    defaultUnit: 'cm',
    min: 130,
    max: 210,
    default: 160,
  },
  {
    id: 'weight_current',
    type: 'ruler-slider-feedback',
    step: 19,
    totalSteps: 21,
    question: 'Qual o seu peso?',
    units: ['kg', 'lb'],
    defaultUnit: 'kg',
    min: 35,
    max: 200,
    default: 60,
    feedback: {
      icon: '🔥',
      template: 'O seu IMC é de {imc}. Isso é ótimo! Vamos te ajudar a ficar ainda mais forte e saudável.',
    },
  },
  // Tela de recapitulação (sem interação, só Continuar) — mostra um resumo
  // do perfil com os dados já coletados até aqui: foto por gênero+body_shape
  // (reaproveitada do step body_shape, sem imagem nova), IMC calculado,
  // e 3 classificações derivadas das respostas anteriores (nunca inventa
  // uma pergunta nova): tipo de corpo vem de body_shape, estilo de vida de
  // daily_activity, condicionamento de push_ups/squats/flexibility e
  // metabolismo de weight_trend. Ver computeProfileSummary em fitnessScore.js.
  {
    id: 'profile_summary',
    type: 'profile-summary',
    step: 20,
    totalSteps: 21,
  },
  {
    id: 'barriers',
    type: 'options-icon',
    step: 21,
    totalSteps: 21,
    i18nKey: 'barriers',
    options: [
      { icon: 'ti-battery-low', value: 'motivacao' },
      { icon: 'ti-clipboard', value: 'sem_plano' },
      { icon: 'ti-alarm', value: 'tempo' },
      { icon: 'ti-bandage', value: 'lesoes' },
      { icon: 'ti-chat', value: 'outro' },
    ],
  },
  // Tela promocional (sem número de step) — gráfico de duas curvas
  // comparando evolução "com FitClutch" x "sem FitClutch", inspirado na
  // estrutura da tela "Befit helps you stay consistent" mas com nosso
  // visual (ciano, não verde) e texto próprio.
  {
    id: 'consistency_chart',
    type: 'consistency-chart',
  },
  // Tela de loading (sem número de step, sem barra de progresso — igual à
  // referência do Befit) com % animado de 0 a 100 e checklist progressivo.
  // Avança sozinha pro email_capture quando termina.
  {
    id: 'progress_loader',
    type: 'progress-loader',
    // Alongada de 3.4s pra 6.2s em 01/10/2026 pra dar tempo do carrossel de
    // depoimentos (4 cards) passar pelo menos uma vez — antes ficava rápido
    // demais e a pessoa só via o primeiro depoimento.
    duration: 6200,
  },
  // Captura de e-mail (lead) — sem barra de progresso, igual à referência.
  {
    id: 'email_capture',
    type: 'email-capture',
  },
  // Cartão-surpresa de desconto, revelado no toque, com confete — igual à
  // estrutura da tela "Open for a surprise!" do Befit (texto/visual
  // próprios). Hoje só mostra pro mercado BR (pt): é o único onde o cupom
  // de boas-vindas de 50% já existe de verdade no Stripe (ver
  // netlify/functions/create-checkout-session.js, STRIPE_COUPON_WEEKLY_WELCOME)
  // — nos outros 7 idiomas o componente pula direto pra próxima tela sem
  // mostrar nada, pra nunca prometer um desconto que ainda não existe de
  // fato no backend desse mercado.
  {
    id: 'discount_reveal',
    type: 'discount-reveal',
  },
  // Removidas em 02/10/2026 (pedido da Gladis, conferindo com os
  // screenshots reais do funil do Befit que seguimos a tela toda essa
  // sessão): experience, frequency, location, age, weight_goal,
  // weight_prediction, plan_type, transformation, value_prop,
  // notification_permission e analyzing eram todas telas remanescentes do
  // quiz antigo (clonado do fitclutch-mobile antes da reconstrução no
  // estilo Befit) — no funil real do concorrente, a ÚLTIMA tela antes da
  // paywall é o email (mercados fora do BR) ou o cupom de desconto (BR),
  // sem nenhuma pergunta nem tela de "analisando..." no meio. A animação de
  // carregamento real já existe mais cedo no funil (progress_loader, ver
  // acima, que já segue a referência "Creating your Personal Workout Plan
  // 0→100%" do Befit) — não duplicamos aqui.
  // `experience` e `location` eram lidas por inferPlanSettingsFromAnswers
  // (aiPlanAdvisor.js) com fallback padrão (intermediate/large gym) quando
  // ausentes — perde um pouco de precisão no plano de exemplo mostrado no
  // paywall internacional, mas não quebra nada. `age` cai no padrão de 30
  // anos em fitnessScore.js/auth.js até decidirmos reintroduzi-la em outro
  // ponto do funil, se for o caso.
  {
    id: 'results',
    type: 'results-score',
    headline: 'É aqui que o progresso começa! 🚀',
    backgroundImage: { male: 'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049989/0021.png', female: 'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049990/00026.png' },
    scoreCard: {
      label: 'FITNESS SCORE',
      percentileTemplate: 'Top {percentil}% dos usuários',
      metrics: [
        { key: 'forca', label: 'Força' },
        { key: 'consistencia', label: 'Consistência' },
        { key: 'recuperacao', label: 'Recuperação' },
        { key: 'aderencia', label: 'Aderência ao objetivo' },
      ],
      projectionTemplate: 'Em 2 meses com o FitClutch: entre {min} e {max}',
      insightTemplate: '{maiorOportunidade} é a sua maior oportunidade de evolução.',
    },
    imcCard: {
      label: 'IMC',
      barRanges: ['Abaixo do peso', 'Peso saudável', 'Sobrepeso', 'Obesidade'],
      projectionTemplate: 'Em 2 meses você estará na faixa de peso mais saudável.',
    },
    cta: 'Criar meu plano',
  },
  {
    id: 'social_proof_map',
    type: 'world-map-proof',
    headlineTemplate: '+{totalUsuarios} usuários no mundo todo escolheram o FitClutch',
    userAvatar: { male: null, female: null },
    highlightRegion: 'auto',
    progressLabel: 'Definindo sua meta',
    progressPercent: 100,
  },
  {
    id: 'plan_preview',
    type: 'plan-preview',
    headline: 'Seu plano personalizado está pronto!',
    highlightWord: 'pronto',
    statsLabels: { workouts: 'Treinos', duration: 'Estimativa', calories: 'Calorias' },
    dayLabelTemplate: 'Dia {n}',
    setsRepsTemplate: '{sets} sets • {reps} reps',
    bodyweightLabel: 'Peso corporal',
    cta: 'Continuar',
  },
  {
    id: 'paywall',
    type: 'paywall-tiers',
    backgroundImages: {
      male: [
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061279/bodybuilding.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061280/02125.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061279/02147.png',
      ],
      female: [
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061279/bodybuilding.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061280/02125.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789061279/02147.png',
      ],
    },
    headline: 'Tenha acesso ao seu plano personalizado',
    benefits: [
      'Treine com um plano personalizado',
      'Progressão de carga real a cada treino',
      'Acompanhe seu progresso na academia',
      'Exercícios novos todos os meses',
    ],
    // ATUALIZADO em 30/09/2026 — decisão fechada com a Gladis (ver
    // fitclutch-app/pesquisa-concorrentes.md, seção "Plano de
    // implementação"): o funil web (fitclutch-app/Stripe) NÃO usa os
    // mesmos preços mensal/anual das lojas — é um produto próprio,
    // estilo Befit: assinatura semanal recorrente, cobrada de verdade
    // já na entrada (não R$0), com desconto de boas-vindas só no
    // primeiro ciclo. Sem upsell pra anual (decisão fechada: "opção a"
    // — continua semanal pra sempre, pelo menos por enquanto).
    // Produto/Price já criado no Stripe: "FitClutch Weekly", BRL 19,90
    // recorrente semanal (ver stripe-setup-progresso.md). O desconto de
    // 50% na primeira fatura é aplicado via `coupon` na criação da
    // sessão de checkout (netlify/functions/create-checkout-session.js),
    // não é um Price separado — por isso só existe UM plano aqui, com os
    // dois valores (cheio e de entrada) pra montar a ancoragem de preço.
    plans: [
      {
        id: 'weekly',
        planId: 'fitclutch_weekly',
        months: 0.25,
        periodLabel: 'semana',
        priceFullLabel: 'R$ 19,90',
        priceEntryLabel: 'R$ 9,95',
        priceTotalLabel: 'R$ 9,95',
        priceMonthlyLabel: 'R$ 9,95',
        discountBadge: '50% OFF NA 1ª SEMANA',
        trialDays: 7,
        highlight: true,
      },
    ],
    // REMOVIDO em 05/10/2026: `intlPlans` (valores PLACEHOLDER em USD que
    // contradiziam a tabela real). Os planos/preços agora vêm do Stripe via
    // netlify/functions/get-prices.js + src/lib/pricing.js (usePlans).
    //
    // Formas de pagamento exibidas em "Checkout 100% Seguro". Os logos ficam
    // em public/payment/<file>.png. SÓ liste aqui o que está HABILITADO no
    // Stripe Checkout da Gladis. Visa/Mastercard/Amex (cartão) + Apple Pay e
    // Google Pay (carteiras automáticas do Stripe Checkout) são certos;
    // PayPal e Discover NÃO foram confirmados → fora da lista até confirmar.
    paymentMethods: [
      { file: 'visa', label: 'Visa' },
      { file: 'mastercard', label: 'Mastercard' },
      { file: 'amex', label: 'American Express' },
      { file: 'apple_pay', label: 'Apple Pay' },
      { file: 'google_pay', label: 'Google Pay' },
    ],
    // Fotos de banco de imagens (Pexels), só pra visual funcionar — a
    // Gladis troca pelas provas sociais de verdade depois.
    // Ordem = depoimentos 1..4 (Marina F, Lucas M, Sofia F, Leo M).
    // Fotos de antes/depois ficam em public/testimonials/ (900x600).
    // null = card sem foto até colocar o arquivo. Imagens ilustrativas.
    intlTestimonialImages: [
      '/testimonials/marina.jpg',
      '/testimonials/lucas.jpg',
      '/testimonials/sofia.jpg',
      '/testimonials/leo.jpg',
    ],
    cta: 'Continuar',
    billingDisclosureTemplate: 'Você paga {precoTotal} agora pela 1ª semana. Depois, {precoCheio} por {periodo}, cobrado automaticamente até você cancelar — sem burocracia, quando quiser.',
    promoCodeLink: 'Usar código promocional',
    footerLinks: ['Restaurar compra', 'Termos', 'Política de privacidade'],
  },
  {
    id: 'upsell_offer',
    type: 'upsell-modal',
    trigger: 'exit-intent-1',
    planId: 'fitclutch_annual_10off',
    headline: 'Continue com desconto especial 🔥',
    subtitle: 'Desbloqueie recursos completos hoje mesmo por um preço especial. Válido somente para esta sessão!',
    countdownSeconds: 116,
    discountBadge: '10% DE DESCONTO',
    priceTotalLabel: 'R$ 134,90',
    priceMonthlyLabel: 'R$ 11,24',
    billingDisclosureTemplate: 'Cobrança de {precoTotal} por ano | Apenas {precoMes} por mês',
    cta: 'Continuar',
  },
  {
    id: 'exit_offer',
    type: 'exit-intent-offer',
    trigger: 'exit-intent-2',
    backgroundImages: {
      male: [
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049990/0254.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049990/00026.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1788963959/19.png',
      ],
      female: [
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049990/0254.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1789049990/00026.png',
        'https://res.cloudinary.com/fdgjhhld/image/upload/v1788963959/19.png',
      ],
    },
    discountBadge: '20% OFF',
    warning: 'Se sair, perderá esta oferta!',
    ribbonLabel: 'OFERTA ÚNICA',
    planLabel: 'Nossa melhor oferta!',
    plan: { planId: 'fitclutch_annual_20off', name: 'Plano Anual', originalPriceLabel: 'R$ 12,49', discountedPriceLabel: 'R$ 9,99', totalPriceLabel: 'R$ 119,90' },
    benefits: ['Exercícios e treinos ilimitados', 'Todos os dados de progresso liberados'],
    billingDisclosureTemplate: 'Cobrança de {precoTotal} por ano, cancelamento a qualquer momento.',
    cta: 'Continuar',
    confirmClose: {
      title: 'Tem certeza de que deseja desistir desta oferta?',
      subtitle: 'Depois de fechá-la, você não poderá resgatar esta oferta novamente.',
      confirmLabel: 'Perder oferta',
      acceptLabel: 'Aceitar oferta',
    },
  },
];

// Etapas do funil linear de onboarding (quiz -> pagamento). Tela de
// avaliação e tutorial da Home foram removidos em 05/10/2026 junto com
// todo o "app dentro do funil" — ver comentário em App.jsx.
export const onboardingFlow = quizSteps;
